export default "__VITE_ASSET__DPrqTGx9__"